<template>
    <div class="BlockList" v-show="bfloag">
        <div class="BlockList-W">
            <img class="imgs" src="../../../assets/pc/Login/close.png" @click="close"/>
            <div class="blockbox">
                <div class="notehead">
                    <div>Important Notes</div>
                </div>
                <div class="notecontent">
                    <div>
                        <p>
                            Please be advised:
                        </p>
                        <p> This round of fund distribution will be available until <span>December 31, 2025</span>.
                        </p>
                        <p>   If you have not received the <span>USDT (U) transfer</span> within the distribution period, please send your relevant basic information to: <span>serve@faircrypto.fund</span>.
                        </p>
                        <p>   For any subsequent supplementary distributions or future reopening schedules, please refer to the official announcements on the <span>Foundation's website</span>. Stay tuned for updates.
                        </p>
                    </div>

                </div>
                <div class="notefoot">
                    <div>Foundation Management Committee</div>
                    <div>December 31, 2025</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ["bflog", "rflog"],
        data() {
            return {
                bfloag: false,
            };
        },
        components: {},
        created() {},
        mounted() {},
        watch: {
            deep: true,
            bflog(val) {
                this.bfloag = val;
            },
            rflog(val) {
                this.bfloag = val;
            },
        },
        methods: {
            close() {
                this.bfloag = false;
                this.$emit("bloflog", this.bfloag);
            },
        },
    };
</script>
<style lang="less">
    /deep/.el-message {
    z-index: 99999999999 !important;
    background-color: #fff !important;
    /* 设置文本颜色为白色 */
    color: white !important;
    /* 其他样式调整，根据需要自行添加 */
}
</style>
<style lang="less" scoped>
.BlockList {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999999999999;
    // background: red;
    width: 100%;
    height: 100%;
    overflow: auto;

.BlockList-W {
        width: 1228px;
        min-height: 249px;
        background: #151515;
        border-radius: 10px 10px 10px 10px;
        opacity: 1;
        position: absolute;
        z-index: 0 !important;
        // border: 1px solid red;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        max-height: 80vh;
    .imgs {
            width: 18px;
            height: 18px;
            margin-right:24px;
            margin-top: 12px;
            cursor: pointer;
            float: right;
        }
    .blockbox {
            width: 1080px;
            margin: 10px auto;
            max-height: 60vh;
            /*font-family: Poppins, Poppins;*/
            overflow-y: auto;
        scroll-behavior: smooth;
        /* 隐藏默认滚动条 */
        /*scrollbar-width: none; !* Firefox *!*/
        -ms-overflow-style: none; /* IE and Edge */
            .notehead{
                font-weight: 600;
                font-size: 40px;
                color: #FFFFFF;
                line-height: 60px;
                text-align: center;
                font-style: normal;
                text-transform: none;
                margin-top: 20px;
            }
            .notecontent{
                font-weight: 400;
                font-size: 20px;
                color: #FFFFFF;
                line-height: 30px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                padding-top: 62px;
                div{
                    width: 1040px;
                }
                /*.note{*/
                /*    height: 180px;*/
                /*}*/
                p{
                   padding: 5px 0;
                }
                span{
                    font-weight: 700;
                    color: #3CF6F0;
                }
                .notetitle{
                    padding: 28px 0;
                    font-size: 40px;
                }
                .noteblod{
                    font-weight: 700;
                }
                h3{
                    font-weight: 700;
                    padding: 24px 0;
                    font-size: 22px;
                    color: #FFFFFF;
                    line-height: 33px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
            }
            .notefoot{
                margin: 46px auto;
                font-weight: 600;
                font-size: 20px;
                padding-right: 26px;
                color: #FFFFFF;
                line-height: 30px;
                text-align: right;
                font-style: normal;
                text-transform: none;
                justify-content: flex-end;

            }
        }
    }
/* WebKit内核浏览器：Chrome、Safari、Edge */
::-webkit-scrollbar { /* 滚动条整体宽度/高度 */
    width: 6px; /* 垂直滚动条宽度 */
    height: 6px; /* 水平滚动条高度 */
}

::-webkit-scrollbar-track { /* 轨道样式 */
    background: #f1f1f1;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb { /* 滑块样式 */
    background: #c1c1c1;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover { /* 滑块 hover 状态 */
    background: #a8a8a8;
}

::-webkit-scrollbar-button { /* 轨道按钮（默认隐藏） */
    display: none;
}
::-webkit-scrollbar {
    display: none;
}

::-webkit-scrollbar-corner { /* 边角样式 */
    background: #f1f1f1;
}
}
</style>
